import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { router } from "@/App";
import { createTheme } from "@/theme";
import { Provider } from "react-redux";
import { persistor, store } from "@/app/store";
import { PersistGate } from "redux-persist/integration/react";
import { Toaster } from "sonner";

const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
          <Toaster richColors position="bottom-right" closeButton />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
